<script>
  import ProgressBar from "./ProgressBar.svelte";
  import { createEventDispatcher } from "svelte";

  const totalSeconds = 40;
  let secondsLeft = totalSeconds;
  let isRunning = false;
  $: progress = ((totalSeconds - secondsLeft) / totalSeconds) * 100;
  const dispatch = createEventDispatcher();
  function startTimer() {
    const timer = setInterval(() => {
      isRunning = true;
      secondsLeft -= 1;
      if (secondsLeft == 0) {
        clearInterval(timer);
        isRunning = false;
        secondsLeft = totalSeconds;
        dispatch("end");
      }
    }, 1000);
  }
</script>

<div bp="grid">
  <h2 bp="offset-5@md 4@md 12@sm">Seconds left: {secondsLeft}</h2>
</div>
<ProgressBar {progress} />
<div bp="grid">
  <button
    class="start"
    bp="offset-5@md 4@md 12@sm"
    on:click={startTimer}
    disabled={isRunning}>Start</button
  >
</div>

<style>
  h2 {
    margin: 0;
  }
  .start {
    background: #38b000;
    width: 100%;
    margin: 10px 0;
  }
  .start[disabled] {
    background: #888;
    cursor: not-allowed;
  }
</style>
